import { render, staticRenderFns } from "./AdminPointRoute.vue?vue&type=template&id=3bae7240&scoped=true"
import script from "./AdminPointRoute.vue?vue&type=script&lang=js"
export * from "./AdminPointRoute.vue?vue&type=script&lang=js"
import style0 from "./AdminPointRoute.vue?vue&type=style&index=0&id=3bae7240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae7240",
  null
  
)

export default component.exports